module.exports = __webpack_public_path__ + "static/media/comparison.037e9770.png";